import * as React from 'react'

import { ColorVariant } from '../checkbox'
import { FinancialsRowDataType } from '../financials-table/types'

export enum View {
  bars,
  lines,
}

export interface ChartProps {
  chartData: ChartData[]
  showTotal?: boolean
  visibleAreas: Array<
    Pick<FinancialsRowDataType, 'id' | 'label' | 'isSelected' | 'isHighlighted'> & {
      color: ColorVariant
    }
  >
  columnsCount: number
  barWidth?: number
  isFullWidth?: boolean
}

export type ChartData = {
  year: string
  topKey: string
  bottomKey: string
  total: number
} & Record<string, number | null>

export enum LineChartTooltipSort {
  default = 'default',
  value = 'value',
}

export type LineStackedBarChartProps = {
  data: FinancialsRowDataType[]
  yearKeys: string[]
  chartView: View
  isShowAll?: boolean
  isFullWidth?: boolean
  hasXAxis?: boolean
  isInView?: boolean
  hasBeenInView?: boolean
  lineChartTooltipSort?: keyof typeof LineChartTooltipSort
  emptyMessage?: React.ReactNode
  isEmpty?: boolean
}
